import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="admin-footer-layout">
            <div className="admin-footer-layout-container">
                <div className="admin-footer-layout-right">
                    <p>
                        Developed &amp; Designed with{' '}
                        <span className="admin-footer-layout-heart">❤️</span>{' '}
                        by{' '}
                        <a
                            href="https://dheersoftwaresolutions.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="admin-footer-layout-link"
                        >
                            Dheer Software Solutions
                        </a>{' '}
                        © 2026 All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;